// Role names returned by the backend (role.name).
export enum RoleName {
  SUPER_ADMIN = "SUPER-ADMIN",
  ADMIN = "ADMIN",
  USER = "USER",
  SCHOOL = "SCHOOL",
  TEACHER = "TEACHER",
}

export const ADMIN_ROLES: string[] = [RoleName.ADMIN, RoleName.SUPER_ADMIN];
export const SCHOOL_MANAGER_ROLES: string[] = [...ADMIN_ROLES, RoleName.SCHOOL];
export const SCHOOL_MEMBER_ROLES: string[] = [
  ...SCHOOL_MANAGER_ROLES,
  RoleName.TEACHER,
];

export const isAdmin = (role?: string) => !!role && ADMIN_ROLES.includes(role);
export const canManageSchool = (role?: string) =>
  !!role && SCHOOL_MANAGER_ROLES.includes(role);
export const canUseAdmin = (role?: string) =>
  !!role && SCHOOL_MEMBER_ROLES.includes(role);

// Landing page after login for each role.
export const homePathFor = (role?: string) =>
  isAdmin(role) ? "/dashboard" : "/classes";
